<template>
    <v-container fluid ref="container" class="pb-0">
        <v-col cols="12" class="ma-0 pa-0">
            <v-data-table
                :headers="filteredHeaders"
                :items="filterWorkOrders"
                class="elevation-0"
                :mobile-breakpoint="0"
                :loading="loading"
                disable-pagination
                hide-default-footer
                :height="`${height}px`"
                multiple-expand
                expanded.sync
                :show-expand="true"
                fixed-header
                style="overflow-y: auto;"
                item-key="partNumberId"
                :item-class="getItemAlertRowClass"
            >
                <template v-slot:top>
                    <v-row
                        no-gutter
                        style="background-color: #eeeeee"
                        class="mt-0 mx-0 pb-0"
                    >
                        <v-col cols="12" sm="4" class="d-flex mb-1 pb-0">
                            <h2 class="mx-4 mt-1">
                                {{
                                    $vuetify.breakpoint.smAndDown
                                        ? 'ITEMS'
                                        : 'ASSEMBLY ITEMS'
                                }}
                            </h2>
                            <v-btn
                                class="mt-1"
                                small
                                icon
                                color="primary"
                                @click="openDeleteAllItem"
                                v-if="
                                    (workOrder.status == 'inProgress' ||
                                        workOrder.status == 'rejected') &&
                                        !readOnlyWO &&
                                        !isAnonymous
                                "
                            >
                                <v-icon>mdi-delete-sweep-outline</v-icon>
                            </v-btn>
                        </v-col>
                        <v-spacer />
                        <v-col
                            cols="12"
                            sm="4"
                            class="d-flex justify-end"
                            v-if="
                                (workOrder.status == 'inProgress' ||
                                    workOrder.status == 'rejected') &&
                                    !readOnlyWO &&
                                    !isAnonymous
                            "
                        >
                            <v-btn
                                rounded
                                color="primary"
                                class="mx-1"
                                @click="openAddItem"
                                :disabled="
                                    loading ||
                                        (workOrder.partNumbers &&
                                            Object.values(workOrder.partNumbers)
                                                .length +
                                                1 >
                                                MAX_WORK_ORDER_ITEMS)
                                "
                                :small="$vuetify.breakpoint.smAndDown"
                            >
                                <v-icon>
                                    mdi-plus
                                </v-icon>
                                {{
                                    $vuetify.breakpoint.smAndDown
                                        ? ''
                                        : 'NEW ITEM'
                                }}
                            </v-btn>
                            <v-btn
                                rounded
                                color="primary"
                                class="mx-1"
                                @click="importFiles"
                                :disabled="loading"
                                :small="$vuetify.breakpoint.smAndDown"
                            >
                                <v-icon>
                                    mdi-login-variant
                                </v-icon>
                                {{
                                    $vuetify.breakpoint.smAndDown
                                        ? ''
                                        : 'IMPORT'
                                }}
                            </v-btn>
                            <v-btn
                                rounded
                                color="primary"
                                class="mx-1"
                                @click="openUploadFiles"
                                :disabled="loading"
                                :small="$vuetify.breakpoint.smAndDown"
                            >
                                <v-icon>
                                    mdi-upload
                                </v-icon>
                                {{
                                    $vuetify.breakpoint.smAndDown ? '' : 'FILES'
                                }}
                            </v-btn>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="4"
                            class="d-flex justify-end px-0"
                            style="flex-wrap: wrap;"
                            v-if="
                                workOrder.status == 'approved' ||
                                    workOrder.status == 'finished'
                            "
                        >
                            <div class="d-flex justify-center pr-3">
                                <v-btn
                                    rounded
                                    color="primary"
                                    class="mx-1"
                                    :disabled="loading"
                                    @click="openMultipleProcesses"
                                    v-if="
                                        !user.operatorRole &&
                                            user.permissions.includes(
                                                'updateWOProcesses'
                                            ) &&
                                            workOrder.status == 'approved' &&
                                            !isAnonymous &&
                                            !readOnlyWO
                                    "
                                    :small="$vuetify.breakpoint.smAndDown"
                                >
                                    <v-icon>
                                        mdi-swap-vertical
                                    </v-icon>
                                    {{
                                        $vuetify.breakpoint.smAndDown
                                            ? ''
                                            : 'SET PROCESSES'
                                    }}
                                </v-btn>
                                <v-btn
                                    rounded
                                    color="primary"
                                    class="mx-1"
                                    :disabled="loading"
                                    @click="openMultipleRegister"
                                    :small="$vuetify.breakpoint.smAndDown"
                                    v-if="!isAnonymous && !readOnlyWO"
                                >
                                    <v-icon class="mr-1">
                                        mdi-tools
                                    </v-icon>
                                    {{
                                        $vuetify.breakpoint.smAndDown
                                            ? ''
                                            : 'REGISTER ITEMS'
                                    }}
                                </v-btn>
                                <v-btn
                                    rounded
                                    color="primary"
                                    class="mx-1"
                                    :disabled="loading"
                                    @click="openMultipleSend"
                                    :small="$vuetify.breakpoint.smAndDown"
                                    v-if="!isAnonymous && !readOnlyWO"
                                >
                                    <v-icon class="mr-1">
                                        mdi-send
                                    </v-icon>
                                    {{
                                        $vuetify.breakpoint.smAndDown
                                            ? ''
                                            : 'SEND ITEMS'
                                    }}
                                </v-btn>
                                <v-btn
                                    rounded
                                    color="primary"
                                    class="mx-1"
                                    :disabled="loading"
                                    @click="openReceiveItems"
                                    v-if="
                                        (workOrder.status == 'approved' ||
                                            workOrder.status == 'finished') &&
                                            user.process &&
                                            !isAnonymous &&
                                            !readOnlyWO
                                    "
                                    :small="$vuetify.breakpoint.smAndDown"
                                >
                                    <v-icon class="mr-1">
                                        mdi-database-arrow-down-outline
                                    </v-icon>
                                    {{
                                        $vuetify.breakpoint.smAndDown
                                            ? ''
                                            : 'RECEIVE ITEMS'
                                    }}
                                </v-btn>
                                <v-btn
                                    rounded
                                    color="primary"
                                    class="mx-1"
                                    :disabled="loading"
                                    @click="openMultipleQuality"
                                    v-if="
                                        user.permissions.includes(
                                            'markQualityRegisters'
                                        ) &&
                                            !isAnonymous &&
                                            !readOnlyWO
                                    "
                                    :small="$vuetify.breakpoint.smAndDown"
                                >
                                    <v-icon class="mr-1">
                                        mdi-check-bold
                                    </v-icon>
                                    {{
                                        $vuetify.breakpoint.smAndDown
                                            ? ''
                                            : 'QUALITY'
                                    }}
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </template>
                <!-- HEADERS -->
                <template v-slot:[`header.processes`]="{ header }">
                    <div class="d-flex justify-center align-center">
                        <v-text-field
                            class="py-2 mt-2"
                            :label="header.text"
                            v-model="processToFilter"
                            dense
                            style="width: 80px;"
                        />
                        <v-spacer />
                        <v-menu rounded offset-y v-if="user.process">
                            <template v-slot:activator="{ attrs, on }">
                                <v-btn
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    depressed
                                >
                                    <v-icon>mdi-sort</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item
                                    @click="
                                        sortByAvailable = !sortByAvailable
                                        sortByProduced = false
                                        sortByDelivered = false
                                    "
                                    :class="{
                                        'selected-item': sortByAvailable,
                                    }"
                                >
                                    <v-list-item-title>
                                        Sort By Available
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="
                                        sortByAvailable = false
                                        sortByProduced = !sortByProduced
                                        sortByDelivered = false
                                    "
                                    :class="{
                                        'selected-item': sortByProduced,
                                    }"
                                >
                                    <v-list-item-title>
                                        Sort By Produced
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="
                                        sortByAvailable = false
                                        sortByProduced = false
                                        sortByDelivered = !sortByDelivered
                                    "
                                    :class="{
                                        'selected-item': sortByDelivered,
                                    }"
                                >
                                    <v-list-item-title>
                                        Sort By Delivered
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </template>
                <!--ITEMS-->
                <template v-slot:[`item.id`]="{ index }">
                    <p class="my-0">
                        {{ index + 1 }}
                    </p>
                </template>
                <template v-slot:[`item.mass`]="{ item }">
                    <div class="d-flex justify-end">
                        <p class="my-0">
                            {{ (Number(item.mass) || 0).toFixed(1) }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.paintingArea`]="{ item }">
                    <div class="d-flex justify-end">
                        <p class="my-0">
                            {{ (Number(item.paintingArea) || 0).toFixed(1) }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.pieceLength`]="{ item }">
                    <div class="d-flex justify-end">
                        <p class="my-0">
                            {{
                                item.pieceLength != null &&
                                item.pieceLength !== ''
                                    ? Number(item.pieceLength).toFixed(1) +
                                      ' (mm)'
                                    : '-'
                            }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.pieceWidth`]="{ item }">
                    <div class="d-flex justify-end">
                        <p class="my-0">
                            {{
                                item.pieceWidth != null &&
                                item.pieceWidth !== ''
                                    ? Number(item.pieceWidth).toFixed(1) +
                                      ' (mm)'
                                    : '-'
                            }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.finishAndUCCode`]="{ item }">
                    <div class="d-flex align-center justify-center">
                        <p class="my-0">
                            <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                    <span
                                        v-on="on"
                                        :style="{ cursor: 'pointer' }"
                                    >
                                        {{
                                            item.finishAndUCCode &&
                                                finishAndUcCodeData &&
                                                finishAndUcCodeData[
                                                    item.finishAndUCCode
                                                ]?.name
                                        }}
                                    </span>
                                </template>
                                <span>
                                    {{
                                        (item.finishAndUCCode &&
                                            finishAndUcCodeData &&
                                            finishAndUcCodeData[
                                                item.finishAndUCCode
                                            ]?.description) ||
                                            'Does not have description'
                                    }}
                                </span>
                            </v-tooltip>
                        </p>
                        <!-- TEMPORARY: tempEditFinishAndUCCode -->
                        <TempEditFinishAndUCCode
                            v-if="editSettingsPermission"
                            :item="item"
                            :work-order="workOrder"
                            :user="user"
                            :setting-finish="settingFinish"
                            :finish-and-uc-code-data="finishAndUcCodeData"
                            @updated="onTempFinishUpdated"
                        />
                    </div>
                </template>
                <template v-slot:[`item.description`]="{ item }">
                    <p class="my-0" style="max-width: 250px">
                        {{ item.description }}
                    </p>
                </template>
                <template v-slot:[`item.assemblyItems`]="{ item }">
                    <p class="my-0" style="max-width: 250px">
                        {{ item.assemblyItems ? item.assemblyItems.length : 0 }}
                    </p>
                </template>

                <template v-slot:[`item.notes`]="{ item }">
                    <p class="my-0" style="max-width: 250px">
                        {{ item.notes }}
                    </p>
                </template>
                <template v-slot:[`item.processes`]="{ item }">
                    <div
                        v-for="process in item.productionInfo"
                        :key="process.id"
                    >
                        <v-tooltip right>
                            <template v-slot:activator="{ on }">
                                <p class="my-0 text-left" v-on="on">
                                    <span
                                        :class="{
                                            'font-weight-bold': user.processes.includes(
                                                process.id
                                            ),
                                        }"
                                    >
                                        {{ process.name }} </span
                                    >: {{ Math.trunc(process.available) }} -
                                    {{ process.produced || 0 }} -
                                    {{ process.delivered }}
                                </p>
                            </template>
                            <span>
                                {{ process.name }}: <br />
                                Available =
                                {{ Math.trunc(process.available || 0) }} ({{
                                    (
                                        ((process.received || 0) * 100) /
                                        item.quantity
                                    ).toFixed(2)
                                }}%)<br />
                                Produced =
                                {{ process.produced || 0 }} ({{
                                    (
                                        ((process.produced || 0) * 100) /
                                        item.quantity
                                    ).toFixed(2)
                                }}%)<br />
                                Delivered =
                                {{ process.delivered }} ({{
                                    (
                                        ((process.delivered || 0) * 100) /
                                        item.quantity
                                    ).toFixed(2)
                                }}%)
                            </span>
                        </v-tooltip>
                    </div>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <div>
                        <v-tooltip right>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    x-small
                                    icon
                                    class="mr-1"
                                    color="white"
                                    style="background-color: #2b81d6;"
                                    v-on="on"
                                >
                                    <p class="my-0">
                                        {{ calculateQualityPending(item) }}
                                    </p>
                                </v-btn>
                                <v-btn
                                    x-small
                                    icon
                                    class="mr-1"
                                    color="white"
                                    style="background-color: #2fbf56;"
                                    v-on="on"
                                >
                                    <p class="my-0">
                                        {{ calculateReleasedQty(item) }}
                                    </p>
                                </v-btn>
                                <v-btn
                                    x-small
                                    icon
                                    class="mr-1"
                                    color="white"
                                    style="background-color: #ffa41d;"
                                    v-on="on"
                                >
                                    <p class="my-0">
                                        {{ calculateReprocessQty(item) }}
                                    </p>
                                </v-btn>
                                <v-btn
                                    x-small
                                    icon
                                    class="mr-1"
                                    color="white"
                                    style="background-color: #FF2610;"
                                    v-on="on"
                                >
                                    <p class="my-0">
                                        {{ calculateRejectedQty(item) }}
                                    </p>
                                </v-btn>
                            </template>
                            <span>
                                Pending :
                                {{ calculateQualityPending(item) || 0 }}
                                <br />
                                Released :
                                {{ calculateReleasedQty(item) }} <br />
                                Reprocess :
                                {{ calculateReprocessQty(item) }} <br />
                                Rejected :
                                {{ calculateRejectedQty(item) }} <br />
                            </span>
                        </v-tooltip>
                    </div>
                </template>
                <template v-slot:[`item.files`]="{ item }">
                    <div
                        class="d-flex justify-center my-0"
                        v-if="item.files != undefined"
                    >
                        <a
                            v-if="item.files.includes(`${item.partNumber}.pdf`)"
                            class="mx-1"
                            @click="loadFiles(item, 'pdf')"
                        >
                            PDF
                        </a>
                        <a
                            v-if="item.files.includes(`${item.partNumber}.dxf`)"
                            class="mx-1"
                            @click="loadFiles(item, 'dxf')"
                        >
                            DXF
                        </a>
                        <a
                            v-if="item.files.includes(`${item.partNumber}.stp`)"
                            class="mx-1"
                            @click="loadFiles(item, 'stp')"
                        >
                            STP
                        </a>
                    </div>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <div>
                        <v-btn
                            small
                            icon
                            color="primary"
                            hide-details
                            @click="openAssemblyForm(item)"
                            v-if="
                                workOrder.status == 'inProgress' ||
                                    workOrder.status == 'rejected'
                            "
                        >
                            <v-icon>mdi-file-tree-outline</v-icon>
                        </v-btn>
                        <v-menu rounded offset-y>
                            <template v-slot:activator="{ attrs, on }">
                                <v-btn
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    depressed
                                >
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item
                                    @click="editItem(item)"
                                    v-if="
                                        (workOrder.status == 'inProgress' ||
                                            workOrder.status == 'rejected' ||
                                            workOrder.status == 'sent' ||
                                            workOrder.status == 'approved') &&
                                            !readOnlyWO
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        Edit Item
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="openAddItemFiles(item)"
                                    v-if="
                                        (workOrder.status == 'inProgress' ||
                                            workOrder.status == 'rejected') &&
                                            !readOnlyWO
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon>mdi-upload</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        Add Item Files
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="openDeleteItem(item)"
                                    v-if="
                                        (workOrder.status == 'inProgress' ||
                                            workOrder.status == 'rejected') &&
                                            !readOnlyWO
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon>mdi-trash-can</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        Delete Item
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="copyItem(item)"
                                    v-if="
                                        (workOrder.status == 'inProgress' ||
                                            workOrder.status == 'rejected') &&
                                            !readOnlyWO
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon>mdi-content-copy</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        Copy Item
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="openArrangeProcesses(item)"
                                    v-if="
                                        workOrder.status == 'approved' &&
                                            !readOnlyWO &&
                                            !user.operatorRole &&
                                            user.permissions.includes(
                                                'updateWOProcesses'
                                            )
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon>mdi-swap-vertical</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        Arrange Processes
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="registerProduction(item)"
                                    v-if="
                                        (workOrder.status == 'approved' ||
                                            workOrder.status == 'finished') &&
                                            !readOnlyWO &&
                                            item &&
                                            activateActions(item)
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon>mdi-tools</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        Register Production
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="sendToPrevProcess(item)"
                                    v-if="
                                        (workOrder.status == 'approved' ||
                                            workOrder.status == 'finished') &&
                                            !readOnlyWO &&
                                            item &&
                                            item.processes &&
                                            item.processes.length > 0 &&
                                            activateActions(item) &&
                                            item.processes[0] != user.process.id
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon
                                            >mdi-arrow-left-circle-outline</v-icon
                                        >
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        Return To Previous Process
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="sendToNextProcess(item)"
                                    v-if="
                                        (workOrder.status == 'approved' ||
                                            workOrder.status == 'finished') &&
                                            !readOnlyWO &&
                                            item &&
                                            item.processes &&
                                            item.processes.length > 1 &&
                                            activateActions(item)
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon>mdi-send</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        Send To Next Process
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="registerQuality(item)"
                                    v-if="
                                        !readOnlyWO &&
                                            item &&
                                            item.processes &&
                                            item.processes.length > 0 &&
                                            activateActions(item) &&
                                            user.permissions.includes(
                                                'markQualityRegisters'
                                            ) &&
                                            (workOrder.status == 'approved' ||
                                                workOrder.status == 'finished')
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon>mdi-check-bold</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        Register Quality
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="openProductionLog(item)"
                                    v-if="
                                        item &&
                                            item.processes &&
                                            item.processes.length > 0 &&
                                            workOrder.status != 'inProgress'
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon>mdi-book-cog-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        Production Log
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="openDeliveryLog(item)"
                                    v-if="
                                        item &&
                                            item.processes &&
                                            workOrder.status != 'inProgress'
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon
                                            >mdi-book-arrow-right-outline</v-icon
                                        >
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        Delivery Log
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="openQualityLog(item)"
                                    v-if="
                                        item &&
                                            item.processes &&
                                            item.processes.length > 0 &&
                                            workOrder.status != 'inProgress'
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon>mdi-book-check-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        Quality Log
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="openDeleteItem(item)"
                                    v-if="
                                        workOrder.status == 'approved' &&
                                            !readOnlyWO &&
                                            permissionToCancelWO &&
                                            (!item.production ||
                                                item.production.length == 0)
                                    "
                                    :disabled="
                                        item.production &&
                                            item.production.length > 0
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon>mdi-trash-can</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        Delete Item
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </template>
                <!--EXPAND TABLE-->
                <template v-slot:expanded-item="{ headers, item: assembly }">
                    <td
                        :colspan="headers.length"
                        class="py-4 ma-0 pl-10 pr-10 outlined"
                        style="background: white"
                    >
                        <div>
                            <v-data-table
                                :headers="itemsHeaders"
                                :items="assembly.assemblyItems"
                                class="ma-0 pa-0 elevation-0"
                                :mobile-breakpoint="0"
                                disable-pagination
                                hide-default-footer
                                style="width: auto !important;"
                            >
                                <!-- ITEMS -->
                                <template v-slot:[`item.id`]="{ index }">
                                    <p class="my-0">
                                        {{ index + 1 }}
                                    </p>
                                </template>
                                <template v-slot:[`item.partNumber`]="{ item }">
                                    <p class="my-0">
                                        {{ item.partNumber }}
                                    </p>
                                </template>

                                <template
                                    v-slot:[`item.qtyPerAssembly`]="{ item }"
                                >
                                    <p class="my-0">
                                        {{ item.qtyPerAssembly }}
                                    </p>
                                </template>
                                <template v-slot:[`item.mass`]="{ item }">
                                    <div class="d-flex justify-end">
                                        <p class="my-0">
                                            {{
                                                Number(item.mass || 0).toFixed(
                                                    1
                                                )
                                            }}
                                        </p>
                                    </div>
                                </template>
                                <template
                                    v-slot:[`item.paintingArea`]="{ item }"
                                >
                                    <div class="d-flex justify-end">
                                        <p class="my-0">
                                            {{
                                                Number(
                                                    item.paintingArea || 0
                                                ).toFixed(1)
                                            }}
                                        </p>
                                    </div>
                                </template>
                                <template v-slot:[`item.totalQty`]="{ item }">
                                    <p class="my-0">
                                        {{
                                            assembly.quantity *
                                                item.qtyPerAssembly
                                        }}
                                    </p>
                                </template>
                                <template
                                    v-slot:[`item.receivedQty`]="{
                                        item,
                                    }"
                                >
                                    <p class="my-0">
                                        {{ getReceivedQty(item, assembly) }}
                                    </p>
                                </template>
                                <template v-slot:[`item.notes`]="{ item }">
                                    <p class="my-0">
                                        {{
                                            getItemInfo(
                                                item.partNumberId,
                                                item.workOrderId
                                            ).notes
                                        }}
                                    </p>
                                </template>
                                <template v-slot:[`item.actions`]="{ item }">
                                    <div>
                                        <v-btn
                                            small
                                            icon
                                            hide-details
                                            @click="
                                                openAssemblyItemDetails(
                                                    item,
                                                    assembly
                                                )
                                            "
                                        >
                                            <v-icon>mdi-eye</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </div>
                    </td>
                </template>

                <!--FOOTER-->
                <template v-slot:[`body.append`]>
                    <tr>
                        <td class="font-weight-bold"></td>
                        <td class="font-weight-bold text-center"></td>
                        <td class="font-weight-bold text-center">
                            TOTAL
                        </td>
                        <td class="font-weight-bold"></td>
                        <td class="font-weight-bold text-right">
                            {{ getTotalMass() }} (kgs)
                        </td>
                        <td class="font-weight-bold text-right">
                            {{ getTotalPaintingArea() }} (m2)
                        </td>
                        <td class="font-weight-bold"></td>
                        <td class="font-weight-bold"></td>
                        <td class="font-weight-bold text-right">
                            {{ totalQuantity }}
                        </td>
                        <td class="font-weight-bold"></td>
                        <td class="font-weight-bold"></td>
                        <td class="font-weight-bold"></td>
                        <td class="font-weight-bold"></td>
                        <td class="font-weight-bold"></td>
                        <td
                            class="font-weight-bold"
                            v-if="
                                workOrder.status == 'approved' ||
                                    workOrder.status == 'closed'
                            "
                        ></td>
                    </tr>
                </template>
            </v-data-table>
        </v-col>
        <!--Assembly Form-->
        <v-dialog
            :retain-focus="false"
            v-model="assemblyForm"
            persistent
            max-width="800px"
        >
            <AssemblyForm
                v-if="assemblyForm"
                :workOrder="workOrder"
                :user="user"
                :settings="settingProcesses"
                :originalItems="partNumbers"
                :parentItem="selectedItem"
                @updatePartNumbers="updatePartNumbers"
                @closeDialog="closeAssemblyForm"
            />
        </v-dialog>
        <!-- Assembly Item Details -->
        <v-dialog
            :retain-focus="false"
            v-model="assemblyItemDetails"
            persistent
            max-width="900px"
        >
            <v-card :loading="loading">
                <v-card-title class="text-h5"
                    ><v-btn
                        class="mr-3"
                        depressed
                        color="primary"
                        icon
                        rounded
                        @click="closeAssemblyItemDetails"
                    >
                        <v-icon>mdi-close</v-icon> </v-btn
                    >Item Deliveries - Part Number:
                    {{ partNumberItemReference }}
                </v-card-title>
                <v-divider class="ml-4 mr-5" />
                <v-card-text>
                    <v-data-table
                        :headers="itemsDetailsHeaders"
                        :items="itemsToShow"
                        class="mt-4 pa-0 elevation-0"
                        :mobile-breakpoint="0"
                        disable-pagination
                        hide-default-footer
                        style="width: auto !important;"
                    >
                        <!-- ITEMS -->
                        <template v-slot:[`item.id`]="{ index }">
                            <p class="my-0">
                                {{ index + 1 }}
                            </p>
                        </template>
                        <template v-slot:[`item.workOrderId`]="{ item }">
                            <p class="my-0">
                                {{ item.workOrderId }}
                            </p>
                        </template>
                        <template
                            v-slot:[`item.receivedQty`]="{
                                item,
                            }"
                        >
                            <p class="my-0">
                                {{ item.receivedQty }}
                            </p>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <div>
                                <v-btn
                                    small
                                    icon
                                    hide-details
                                    @click="
                                        deleteAssemblyItem(
                                            item,
                                            selectedAssembly
                                        )
                                    "
                                    v-if="
                                        (workOrder.status == 'inProgress' ||
                                            workOrder.status == 'rejected') &&
                                            getReceivedQty(
                                                item,
                                                selectedAssembly
                                            ) == 0
                                    "
                                >
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                                <v-btn
                                    small
                                    icon
                                    hide-details
                                    @click="
                                        openEditAssemblyItem(
                                            item,
                                            selectedAssembly
                                        )
                                    "
                                    v-if="
                                        workOrder.status == 'inProgress' ||
                                            workOrder.status == 'rejected'
                                    "
                                >
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </div>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- Assembly Item Dialog -->
        <v-dialog
            :retain-focus="false"
            v-model="editAssemblyItemDialog"
            persistent
            max-width="400px"
        >
            <v-card :loading="loading">
                <v-card-title class="text-h5"
                    >Assembly Item
                    {{ selectedAssemblyItem.partNumber }}</v-card-title
                >
                <v-divider class="ml-4 mr-5" />
                <v-card-text>
                    <v-form v-model="valid" class="mt-3 mr-2">
                        <v-col cols="12" class="pt-0 pb-1 px-0">
                            <v-text-field
                                v-model="selectedAssemblyItem.qtyPerAssembly"
                                prepend-icon="mdi-file-tree-outline"
                                prefix="Qty Per Assembly:"
                                type="number"
                                required
                                class="ma-0"
                                :suffix="`x${selectedItem.quantity}`"
                                :rules="[() => maxValue()]"
                            />
                        </v-col>
                        <v-row class="mt-0">
                            <v-col cols="6" class="d-flex align-center pb-3">
                                <div class="d-flex align-center">
                                    <v-icon class="pr-2"
                                        >mdi-database-outline</v-icon
                                    >
                                    <p class="mb-0">
                                        Available Qty: {{ availableQty }}
                                    </p>
                                </div>
                            </v-col>
                            <v-col cols="6" class="d-flex align-center pb-3">
                                <div class="d-flex align-center">
                                    <v-icon class="pr-2"
                                        >mdi-database-outline</v-icon
                                    >
                                    <p class="mb-0">
                                        Total Qty:
                                        {{
                                            selectedItem.quantity *
                                                selectedAssemblyItem.qtyPerAssembly
                                        }}
                                    </p>
                                </div>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pb-3 pt-0">
                    <v-btn
                        text
                        color="secondary"
                        @click="closeEditAssemblyItem"
                    >
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        :disabled="
                            !valid ||
                                this.initialQty ==
                                    selectedAssemblyItem.qtyPerAssembly
                        "
                        @click="updateAssemblyItem"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import moment from 'moment'
import API from '@/services/api'
import { mapMutations } from 'vuex'
import qrious from 'qrious'
import _ from 'lodash'
import { firestore } from '@/services/firebase'
import { loadImage } from '@/helpers/imageHandler.js'
import WOMethods from './WOMethods.js'
import { MAX_WORK_ORDER_ITEMS } from '@/constants/workOrderLimits'

export default {
    name: 'AssemblyItems',
    props: {
        workOrder: {
            type: Object,
            required: true,
        },
        readOnlyWO: {
            type: Boolean,
            default: () => false,
        },
        isAnonymous: {
            type: Boolean,
            default: () => false,
        },
        height: {
            type: Number,
            default: () => 0,
        },
        settingFinish: { type: Object, default: () => {} },
        partNumbers: { type: Array, default: () => [] },
    },
    components: {
        AssemblyForm: () => import('@/components/WorkOrders/AssemblyForm.vue'),
        // TEMPORARY: remove when temp finish edit feature is retired
        TempEditFinishAndUCCode: () =>
            import(
                '@/components/WorkOrders/tempEditFinishAndUCCode/TempEditFinishAndUCCode.vue'
            ),
    },
    data: () => ({
        MAX_WORK_ORDER_ITEMS,
        selectedItem: {},
        loading: false,
        headers: [
            {
                text: 'ID',
                value: 'id',
                align: 'center',
                sortable: false,
                width: 50,
            },
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'DESCRIPTION',
                value: 'description',
                align: 'left',
                sortable: false,
            },
            {
                text: 'MASS',
                value: 'mass',
                align: 'right',
                sortable: false,
            },
            {
                text: 'PAINTING AREA',
                value: 'paintingArea',
                align: 'right',
                sortable: false,
            },
            {
                text: 'LENGTH',
                value: 'pieceLength',
                align: 'right',
                sortable: false,
            },
            {
                text: 'WIDTH',
                value: 'pieceWidth',
                align: 'right',
                sortable: false,
            },
            {
                text: 'FINISH & UC CODE',
                value: 'finishAndUCCode',
                align: 'center',
                sortable: false,
            },
            {
                text: 'QTY',
                value: 'quantity',
                align: 'right',
                sortable: false,
            },
            {
                text: 'ASSEMBLY ITEMS',
                value: 'assemblyItems',
                align: 'center',
                sortable: false,
            },
            {
                text: 'NOTES',
                value: 'notes',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PROCESSES',
                value: 'processes',
                align: 'left',
                sortable: false,
            },
            {
                text: 'FILES',
                value: 'files',
                align: 'center',
                sortable: false,
            },
            {
                text: 'OC',
                value: 'oc',
                align: 'left',
                sortable: false,
            },
            {
                text: 'POSITION',
                value: 'costPosition',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                align: 'center',
                sortable: false,
            },
        ],
        itemsHeaders: [
            {
                text: 'ID',
                value: 'id',
                align: 'center',
                sortable: false,
                width: 50,
            },
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'MASS',
                value: 'mass',
                align: 'right',
                sortable: false,
            },
            {
                text: 'PAINTING AREA',
                value: 'paintingArea',
                align: 'right',
                sortable: false,
            },
            {
                text: 'QTY PER ASSEMBLY',
                value: 'qtyPerAssembly',
                align: 'center',
                sortable: false,
            },
            {
                text: 'TOTAL QTY',
                value: 'totalQty',
                align: 'center',
                sortable: false,
            },
            {
                text: 'USED QTY',
                value: 'receivedQty',
                align: 'center',
                sortable: false,
            },
            {
                text: 'NOTES',
                value: 'notes',
                align: 'left',
                sortable: false,
            },
        ],
        itemsDetailsHeaders: [
            {
                text: 'ID',
                value: 'id',
                align: 'center',
                sortable: false,
                width: 50,
            },
            {
                text: 'WORK ORDER',
                value: 'workOrderId',
                align: 'center',
                sortable: false,
            },
            {
                text: 'RECEIVED QTY',
                value: 'receivedQty',
                align: 'center',
                sortable: false,
            },
        ],
        companyId: JSON.parse(localStorage.getItem('company')),
        settingProcesses: undefined,
        file: null,
        user: {},
        permissionToCancelWO: false,
        // TEMPORARY: remove when temp finish edit feature is retired
        editSettingsPermission: false,
        permissionToApproveWO: false,
        packingDialog: false,
        qualityProcess: {
            id: 'quality',
            name: 'Quality',
        },
        readyForPackingProcess: {
            id: 'readyForPacking',
            name: 'Ready for packing',
        },
        packingProcess: {
            id: 'packing',
            name: 'Packing',
        },
        prevProcessDialog: false,
        qualityDialog: false,
        multipleQualityDialog: false,
        viewType: null,
        itemLogDialog: false,
        processToFilter: undefined,
        sortByAvailable: false,
        sortByProduced: false,
        sortByDelivered: false,
        assemblyForm: false,
        projectWorkOrders: [],
        projectWOItems: [],
        selectedAssemblyItem: {},
        editAssemblyItemDialog: false,
        availableQty: 0,
        valid: false,
        initialQty: 0,
        partNumbersNotFound: [],
        woMethods: new WOMethods(),
        openItemFiles: false,
        woItems: [],
        itemsToShow: [],
        selectedAssembly: {},
        assemblyItemDetails: false,
        partNumberItemReference: '',
        partNumbersCatalog: [],
        formattingWOItems: false,
        partNumbersProductionData: {},
        finishAndUcCodeData: {},
        workOrderAlerts: [],
        alertsUnsubscribe: null,
    }),
    computed: {
        filteredHeaders() {
            // Filter out actions column if user is anonymous
            if (this.isAnonymous) {
                return this.headers.filter(header => header.value !== 'actions')
            }
            return this.headers
        },
        bypassAssemblyStock() {
            return !!(
                this.workOrder &&
                this.workOrder.assemblyWorkOrder &&
                this.workOrder.reprocess &&
                this.workOrder.warranty
            )
        },
        effectivePartNumbers() {
            return this.partNumbersCatalog?.length
                ? this.partNumbersCatalog
                : this.partNumbers || []
        },
        filterWorkOrders() {
            let conditions = []
            let items = this.woItems
            if (this.processToFilter) {
                conditions.push(this.filterByProcess)
            }
            if (conditions.length > 0) {
                return items.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }
            if (
                (this.sortByAvailable ||
                    this.sortByProduced ||
                    this.sortByDelivered) &&
                this.user.process
            ) {
                const auxItems = _.cloneDeep(items)
                const sortedItems = this.sort(auxItems)
                return sortedItems
            } else if (
                !this.sortByAvailable &&
                !this.sortByProduced &&
                !this.sortByDelivered &&
                this.user.process
            ) {
                items.sort((a, b) => {
                    const last4DigitsA = parseInt(
                        (a.partNumber || '').slice(-4),
                        10
                    )
                    const last4DigitsB = parseInt(
                        (b.partNumber || '').slice(-4),
                        10
                    )
                    return last4DigitsA - last4DigitsB
                })
                return items
            }

            return items
        },

        totalMass() {
            return this.workOrder.items
                ? this.workOrder.items.reduce(
                      (accumulator, item) =>
                          accumulator + item.mass * item.quantity,
                      0
                  )
                : 0
        },
        totalPaintingArea() {
            return this.workOrder.items
                ? this.workOrder.items.reduce(
                      (accumulator, item) =>
                          accumulator + item.paintingArea * item.quantity,
                      0
                  )
                : 0
        },
        totalQuantity() {
            return this.workOrder.items
                ? this.workOrder.items.reduce(
                      (accumulator, item) => accumulator + +item.quantity,
                      0
                  )
                : 0
        },
    },
    watch: {
        'workOrder.id': {
            handler() {
                this.scheduleFormatWOItems()
            },
        },
        'workOrder.items': {
            handler() {
                this.scheduleFormatWOItems()
            },
        },
        partNumbers: {
            handler(newVal) {
                if (newVal?.length) {
                    this.partNumbersCatalog = newVal
                    this.scheduleFormatWOItems()
                }
            },
        },
    },
    async mounted() {
        try {
            this.loading = true
            // set project manager
            const {
                data: { user },
            } = await API.getMyInfo()

            user.processes = []
            if (user.process?.length > 0) {
                user.process.forEach(process => {
                    user.processes.push(process.id)
                })
            }

            this.user = user
            // TEMPORARY: remove when temp finish edit feature is retired
            this.editSettingsPermission = user.permissions.includes(
                'editSettings'
            )
            await this.syncPartNumbersCatalog()
            // Get companyId for request (use route query for anonymous users)
            const companyIdForProjectWOs =
                this.user?.name === 'AnonymousSession' &&
                this.$route.query.companyId
                    ? this.$route.query.companyId
                    : undefined
            this.projectWorkOrders = await API.getWorkOrdersByProject({
                projectId: this.workOrder.projectId,
                includeClosed: false,
                companyId: companyIdForProjectWOs,
            })
            this.projectWorkOrders.forEach(wo => {
                wo = this.woMethods.formatItems(wo)
                if (wo.items) {
                    wo.items.forEach(item => {
                        if (wo.status == 'approved' || wo.status == 'sent') {
                            this.projectWOItems.push({
                                workOrder: wo.code,
                                type: wo.assemblyWorkOrder
                                    ? 'Assembly'
                                    : 'Production',
                                availableQty:
                                    Number(item.quantity) -
                                    Number(item.qtyInAssembly || 0),
                                workOrderId: wo.id,
                                ...item,
                                partNumber:
                                    item.partNumber ||
                                    this.resolvePartNumberDisplay(item),
                            })
                        }
                    })
                }
            })
            this.formatWOItems()
            // Get companyId for request (use route query for anonymous users)
            const companyIdForProductionData =
                this.user?.name === 'AnonymousSession' &&
                this.$route.query.companyId
                    ? this.$route.query.companyId
                    : undefined
            this.partNumbersProductionData = await API.getPartNumbersProductionData(
                this.workOrder.projectId,
                companyIdForProductionData
            )
            this.formatPartNumbers()
            // set finish and uc code in keys
            this.finishAndUcCodeData = {}
            if (this.settingFinish && this.settingFinish.finishes) {
                this.settingFinish.finishes.forEach(finish => {
                    this.finishAndUcCodeData[finish.id] = finish
                })
            }
            // retrieve permission to cancel a WO
            this.permissionToCancelWO = user.permissions.includes('cancelWO')
            // qr code
            new qrious({
                element: document.getElementById('qr'),
                value: `${process.env.VUE_APP_CLIENT_HOST}/work-orders/main-work-orders?orderId=${this.workOrder.id}`,
            })
            if (
                this.workOrder.status == 'approved' ||
                this.workOrder.status == 'closed'
            ) {
                this.headers.splice(9, 0, {
                    text: 'STATUS',
                    value: 'status',
                    align: 'center',
                    sortable: false,
                    width: 100,
                })
            }

            // Only add actions column if user is not anonymous
            if (!this.isAnonymous) {
                if (
                    this.workOrder.status == 'inProgress' ||
                    this.workOrder.status == 'rejected'
                ) {
                    this.itemsDetailsHeaders.push({
                        text: 'ACTIONS',
                        value: 'actions',
                        align: 'center',
                        sortable: false,
                    })
                }
                this.itemsHeaders.push({
                    text: 'ACTIONS',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                })
            }
            await this.loadWorkOrderAlerts()
            this.formatWOItems()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    beforeDestroy() {
        if (this.alertsUnsubscribe) {
            this.alertsUnsubscribe()
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async loadWorkOrderAlerts() {
            try {
                this.alertsUnsubscribe = firestore
                    .collection('companies')
                    .doc(this.companyId)
                    .collection('alerts')
                    .doc(this.workOrder.id)
                    .onSnapshot(
                        snapshot => {
                            if (snapshot.exists) {
                                const data = snapshot.data()
                                this.workOrderAlerts = data?.alerts || []
                            } else {
                                this.workOrderAlerts = []
                            }
                        },
                        error => {
                            console.error('Error listening to alerts:', error)
                        }
                    )
            } catch (error) {
                console.error('Error setting up alerts listener:', error)
                this.workOrderAlerts = []
            }
        },
        getItemAlertSummary(item) {
            const partNumberId = item.partNumberId || item.id
            const relevantAlerts = Object.values(this.workOrderAlerts).filter(
                alert => {
                    if (
                        !alert.selectedPartNumbers ||
                        !Array.isArray(alert.selectedPartNumbers)
                    ) {
                        return false
                    }
                    return alert.selectedPartNumbers.some(
                        pn => pn.id === partNumberId
                    )
                }
            )

            const summary = {
                hasAlerts: relevantAlerts.length > 0,
                total: relevantAlerts.length,
                open: 0,
                pendingApproval: 0,
                resolved: 0,
                allResolved: false,
            }

            relevantAlerts.forEach(alert => {
                if (alert.status === 'done') {
                    summary.resolved++
                } else if (alert.status === 'pending_approval') {
                    summary.pendingApproval++
                } else {
                    summary.open++
                }
            })

            summary.allResolved =
                summary.resolved > 0 &&
                summary.open === 0 &&
                summary.pendingApproval === 0

            return summary
        },
        getItemAlertRowClass(item) {
            const summary = this.getItemAlertSummary(item)
            if (!summary.hasAlerts) return ''

            if (summary.pendingApproval > 0) {
                return 'alert-pending-approval-row'
            }
            if (summary.open > 0) {
                return 'alert-open-row'
            }
            if (summary.allResolved && summary.total > 0) {
                return 'alert-resolved-row'
            }
            return ''
        },
        async syncPartNumbersCatalog() {
            if (this.partNumbers?.length) {
                this.partNumbersCatalog = this.partNumbers
                return
            }
            if (this.partNumbersCatalog?.length) {
                return
            }
            const companyId =
                this.user?.name === 'AnonymousSession' &&
                this.$route.query.companyId
                    ? this.$route.query.companyId
                    : this.companyId
            this.partNumbersCatalog = await API.getPartNumbers(
                this.workOrder.projectId,
                null,
                companyId
            )
        },
        resolvePartNumberDisplay(item) {
            if (!item) {
                return ''
            }
            if (item.partNumber) {
                return item.partNumber
            }
            const partNumberId = item.partNumberId || item.id
            if (!partNumberId) {
                return ''
            }
            const fromWorkOrder = this.workOrder.partNumbers?.[partNumberId]
            if (fromWorkOrder?.partNumber) {
                return fromWorkOrder.partNumber
            }
            if (fromWorkOrder?.code) {
                return fromWorkOrder.code
            }
            const catalog = this.effectivePartNumbers
            const matchById = catalog.find(pn => pn.id === partNumberId)
            if (matchById?.code) {
                return matchById.code
            }
            const matchByCode = catalog.find(pn => pn.code === partNumberId)
            if (matchByCode?.code) {
                return matchByCode.code
            }
            return ''
        },
        scheduleFormatWOItems() {
            if (this.formattingWOItems) {
                return
            }
            this.$nextTick(() => {
                if (!this.formattingWOItems) {
                    this.formatWOItems()
                }
            })
        },
        applyPartNumberLabelsToItems() {
            for (const item of this.woItems) {
                const label = this.resolvePartNumberDisplay(item)
                if (label) {
                    item.partNumber = label
                }
                if (!item.assemblyItems?.length) {
                    continue
                }
                for (const assemblyGroup of item.assemblyItems) {
                    const groupLabel = this.resolvePartNumberDisplay(
                        assemblyGroup
                    )
                    if (groupLabel) {
                        assemblyGroup.partNumber = groupLabel
                    }
                    if (!assemblyGroup.items?.length) {
                        continue
                    }
                    for (const subItem of assemblyGroup.items) {
                        const subLabel = this.resolvePartNumberDisplay(subItem)
                        if (subLabel) {
                            subItem.partNumber = subLabel
                        }
                    }
                }
            }
        },
        formatWOItems() {
            if (this.formattingWOItems) {
                return
            }
            this.formattingWOItems = true
            // Work on clones so we do not mutate the workOrder prop (avoids watcher loops)
            this.woItems = this.workOrder.items
                ? this.workOrder.items.map(item => _.cloneDeep(item))
                : []
            for (const item of this.woItems) {
                if (item.assemblyItems) {
                    const assemblyItems = _.cloneDeep(item.assemblyItems)
                    item.assemblyItems = _.cloneDeep([])
                    assemblyItems.forEach(assemblyItem => {
                        const matchedProjectItem = this.projectWOItems.find(
                            projectItem =>
                                projectItem.partNumberId ===
                                assemblyItem.partNumberId
                        )
                        const workOrderId =
                            matchedProjectItem?.workOrderId ||
                            assemblyItem.workOrderId
                        const workOrderCode =
                            matchedProjectItem?.workOrder || 'N/A'

                        assemblyItem.itemDeliveries = this.getItemInfo(
                            assemblyItem.partNumberId,
                            workOrderId
                        ).deliveries
                        const assemblyPartNumberCode = this.resolvePartNumberDisplay(
                            assemblyItem
                        )
                        const foundGroupedAssembly = item.assemblyItems.find(
                            groupedAssembly =>
                                groupedAssembly.partNumber &&
                                groupedAssembly.partNumber ===
                                    assemblyPartNumberCode
                        )
                        if (!foundGroupedAssembly && assemblyPartNumberCode) {
                            const partNumbersList = assemblyItems.filter(
                                otherAssemblyItem =>
                                    this.resolvePartNumberDisplay(
                                        otherAssemblyItem
                                    ) === assemblyPartNumberCode
                            )

                            this.partNumberItemReference = assemblyPartNumberCode

                            const groupedAssemblyEntry = {
                                partNumber: assemblyPartNumberCode,
                                items: partNumbersList,
                                description: this.getItemInfo(
                                    assemblyItem.partNumberId,
                                    workOrderId
                                ).description,
                                mass: this.projectWOItems.find(
                                    projectItem =>
                                        projectItem.partNumberId ===
                                        assemblyItem.partNumberId
                                )?.mass,
                                paintingArea: this.projectWOItems.find(
                                    projectItem =>
                                        projectItem.partNumberId ===
                                        assemblyItem.partNumberId
                                )?.paintingArea,
                                qtyPerAssembly: assemblyItem.qtyPerAssembly,
                                deliveries: assemblyItem.deliveries,
                                workOrderId: workOrderCode,
                            }
                            item.assemblyItems.push(groupedAssemblyEntry)
                        }
                    })
                }
                const mass =
                    (item.mass == 0 || !item.mass) &&
                    (item.paintingArea == 0 || !item.paintingArea)
                        ? this.getAssemblyMass(item).toFixed(1)
                        : item.mass

                const paintingArea =
                    (item.mass == 0 || !item.mass) &&
                    (item.paintingArea == 0 || !item.paintingArea)
                        ? this.getAssemblyPaintingArea(item).toFixed(1)
                        : item.paintingArea

                item.mass = mass
                item.paintingArea = paintingArea
            }
            this.applyPartNumberLabelsToItems()
            this.$nextTick(() => {
                this.formattingWOItems = false
            })
        },
        editItem(item) {
            this.$emit('editItem', item)
        },
        // TEMPORARY: remove when temp finish edit feature is retired
        onTempFinishUpdated(item) {
            this.$emit('replaceItem', item)
        },
        async copyItem(item) {
            this.$emit('copyItem', item)
        },
        openDeleteItem(item) {
            this.$emit('openDeleteItem', item)
        },
        openDeleteAllItem() {
            this.$emit('openDeleteAllItem')
        },
        async loadFiles(item, extension) {
            try {
                this.loading = true
                var url = await loadImage(
                    `${this.companyId}/workOrders/${this.workOrder.id}/items`,
                    item.partNumber + '.' + extension
                )
                if (url) {
                    setTimeout(() => {
                        window.open(url, '_blank')
                        this.loading = false
                    })
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        openUploadFiles() {
            this.$emit('openUploadFiles')
        },
        openAddItemFiles(item) {
            this.$emit('openAddItemFiles', item)
        },
        openAddItem() {
            this.$emit('openAddItem')
        },
        formatDate(seconds) {
            return `${moment.unix(seconds).format('L')} ${moment
                .unix(seconds)
                .format('LT')}`
        },
        openArrangeProcesses(item) {
            this.$emit('openArrangeProcesses', item)
        },
        sendToPrevProcess(item) {
            this.$emit('sendToPrevProcess', item)
        },
        sendToNextProcess(item) {
            this.$emit('sendToNextProcess', item)
        },
        registerProduction(item) {
            this.$emit('registerProduction', item)
        },
        activateActions(item) {
            return (
                !this.loading &&
                item.processes &&
                this.user.process &&
                Array.isArray(this.user.process) &&
                this.user.process.some(userProc =>
                    item.processes.includes(userProc.id)
                )
            )
        },
        openMultipleProcesses() {
            this.$emit('openMultipleProcesses')
        },
        openMultipleRegister() {
            this.$emit('openMultipleRegister', { forAssemblyOrder: true })
        },
        openMultipleSend() {
            this.$emit('openMultipleSend')
        },
        registerQuality(item) {
            this.$emit('registerQuality', item)
        },
        openMultipleQuality() {
            this.$emit('openMultipleQuality')
        },
        calculateQualityPending(item) {
            try {
                let pendingQty = 0
                if (item.processes) {
                    let lastProcessIndex = item.processes.length - 1
                    if (this.workOrder.assemblyWorkOrder != undefined) {
                        lastProcessIndex =
                            item.processes.findIndex(
                                p => p == this.qualityProcess.id
                            ) - 1
                    }
                    if (lastProcessIndex > -1) {
                        const lastProductionProcess =
                            item.processes[lastProcessIndex]
                        if (item.production) {
                            const production = item.production.filter(
                                entry =>
                                    entry.process.id == lastProductionProcess
                            )
                            if (production.length > 0) {
                                pendingQty = production.reduce(
                                    (accumulator, entry) =>
                                        accumulator + entry.qty,
                                    0
                                )
                            }
                        }
                        if (item.quality) {
                            const rejected = item.quality.reduce(
                                (accumulator, entry) =>
                                    accumulator + (entry.rejectQty || 0),
                                0
                            )
                            const released = item.quality.reduce(
                                (accumulator, entry) =>
                                    accumulator + (entry.releaseQty || 0),
                                0
                            )
                            pendingQty -=
                                Number(released || 0) + Number(rejected || 0)
                        }
                    }
                }

                return pendingQty
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateReleasedQty(item) {
            try {
                let released = 0
                if (item.quality) {
                    const value = item.quality.reduce(
                        (accumulator, entry) =>
                            accumulator + (entry.releaseQty || 0),
                        0
                    )
                    released += Number(value || 0)
                }
                return released
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateReprocessQty(item) {
            try {
                let reprocess = 0
                if (item.quality) {
                    const value = item.quality.reduce(
                        (accumulator, entry) =>
                            accumulator + (entry.reprocessQty || 0),
                        0
                    )
                    reprocess += Number(value || 0)
                }
                return reprocess
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateRejectedQty(item) {
            try {
                let rejected = 0
                if (item.quality) {
                    const value = item.quality.reduce(
                        (accumulator, entry) =>
                            accumulator + (entry.rejectQty || 0),
                        0
                    )
                    rejected += Number(value || 0)
                }
                return rejected
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        openProductionLog(item) {
            this.$emit('openProductionLog', item)
        },
        openDeliveryLog(item) {
            this.$emit('openDeliveryLog', item)
        },
        openQualityLog(item) {
            this.$emit('openQualityLog', item)
        },
        filterByProcess(item) {
            let processesString = ''
            item.dataProcesses.forEach(process => {
                if (item.processes.includes(process.id)) {
                    processesString += ` ${process.name}`
                }
            })
            return processesString
                .toLowerCase()
                .includes(this.processToFilter.toLowerCase())
        },
        sort(items) {
            const process = this.user.process.id

            if (this.sortByAvailable) {
                items.sort((a, b) => {
                    const productionA = a.productionInfo.find(
                        p => p.id === process
                    )
                    const productionB = b.productionInfo.find(
                        p => p.id === process
                    )
                    return (
                        (productionB?.available || 0) -
                        (productionA?.available || 0)
                    )
                })
            } else if (this.sortByProduced) {
                items.sort((a, b) => {
                    const productionA = a.productionInfo.find(
                        p => p.id === process
                    )
                    const productionB = b.productionInfo.find(
                        p => p.id === process
                    )
                    return (
                        (productionB?.produced || 0) -
                        (productionA?.produced || 0)
                    )
                })
            } else if (this.sortByDelivered) {
                items.sort((a, b) => {
                    const productionA = a.productionInfo.find(
                        p => p.id === process
                    )
                    const productionB = b.productionInfo.find(
                        p => p.id === process
                    )
                    return (
                        (productionB?.delivered || 0) -
                        (productionA?.delivered || 0)
                    )
                })
            }
            return items
        },
        closeDialog() {
            this.$emit('close')
        },
        openAssemblyForm(item) {
            this.assemblyForm = true
            this.selectedItem = _.cloneDeep(item)
        },
        closeAssemblyForm() {
            this.assemblyForm = false
            this.selectedItem = {}
        },
        getItemInfo(partNumberId, workOrderId) {
            let item = {
                workOrder: '',
                partNumber: '',
                description: '',
                notes: '',
                mass: 0,
                paintingArea: 0,
                deliveries: [],
            }

            const index = this.projectWOItems.findIndex(
                i =>
                    i.partNumberId == partNumberId &&
                    i.workOrderId == workOrderId
            )
            if (index > -1) {
                item = this.projectWOItems[index]
            }
            return item
        },
        async deleteAssemblyItem(item, parent) {
            try {
                this.loading = true
                await API.removeAssemblyItem({
                    assemblyPartNumberId: item.partNumberId,
                    workOrderId: this.workOrder.id,
                    partNumberId: parent.partNumberId,
                })
                this.closeAssemblyItemDetails()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async updateAssemblyItem() {
            try {
                this.loading = true
                await API.updateAssemblyItem({
                    item: {
                        partNumberId: this.selectedAssemblyItem.partNumberId,
                        qtyPerAssembly: this.selectedAssemblyItem
                            .qtyPerAssembly,
                        workOrderId: this.selectedAssemblyItem.workOrderId,
                    },
                    workOrderId: this.workOrder.id,
                    partNumberId: this.selectedItem.partNumberId,
                })
                this.closeAssemblyItemDetails()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        openEditAssemblyItem(item, parent) {
            this.selectedItem = _.cloneDeep(parent)
            this.selectedAssemblyItem = item
            this.availableQty = this.partNumbersProductionData[
                item.partNumberId
            ].available

            this.editAssemblyItemDialog = true
        },
        closeEditAssemblyItem() {
            this.selectedItem = {}
            this.selectedAssemblyItem = {}
            this.availableQty = 0
            this.editAssemblyItemDialog = false
        },
        maxValue() {
            if (this.bypassAssemblyStock) {
                return true
            }
            const totalValue =
                Number(this.selectedAssemblyItem.qtyPerAssembly) *
                Number(this.selectedItem.quantity)

            if (totalValue > this.availableQty) {
                return `The quantity selected cannot be greater than ${Math.floor(
                    Number(this.availableQty) /
                        Number(this.selectedItem.quantity)
                )}`
            } else if (this.selectedAssemblyItem.qtyPerAssembly <= 0) {
                return 'The value must be positive'
            } else {
                return true
            }
        },
        getReceivedQty(item, assembly) {
            if (!item || !assembly) {
                return 0
            }

            // Get the produced quantity from the parent assembly
            let producedQty = 0

            if (assembly.productionInfo && assembly.productionInfo.length > 0) {
                // Find the first production process (excluding quality and packing)
                const firstProductionProcess = assembly.productionInfo.find(
                    p =>
                        p.id !== this.qualityProcess.id &&
                        p.id !== this.packingProcess.id &&
                        p.id !== this.readyForPackingProcess.id
                )

                if (firstProductionProcess) {
                    producedQty = firstProductionProcess.produced || 0
                } else if (assembly.productionInfo.length > 0) {
                    // Fallback to first process if no production process found
                    producedQty = assembly.productionInfo[0].produced || 0
                }
            }

            // Calculate: qtyPerAssembly * produced quantity of assembly
            const qtyPerAssembly = Number(item.qtyPerAssembly || 0)
            const receivedQty = qtyPerAssembly * producedQty

            return Math.trunc(receivedQty)
        },
        getAssemblyMass(item) {
            let totalMass = 0
            if (item.assemblyItems) {
                totalMass = item.assemblyItems.reduce(
                    (accumulator, assemblyItem) =>
                        accumulator +
                        assemblyItem.qtyPerAssembly * (assemblyItem.mass || 0),
                    0
                )
            }
            return totalMass
        },
        getAssemblyPaintingArea(item) {
            let totalPaintingArea = 0
            if (item.assemblyItems) {
                totalPaintingArea = item.assemblyItems.reduce(
                    (accumulator, assemblyItem) =>
                        accumulator +
                        assemblyItem.qtyPerAssembly *
                            (assemblyItem.paintingArea || 0),
                    0
                )
            }
            return totalPaintingArea
        },
        getTotalMass() {
            let totalMassWo = 0
            if (this.workOrder.items && this.workOrder.items.length > 0) {
                this.workOrder.items.forEach(item => {
                    totalMassWo += (+item.mass || 0) * (+item.quantity || 0)
                })
            }
            return Number(totalMassWo || 0).toFixed(1)
        },
        getTotalPaintingArea() {
            let totalPaintingAreaWo = 0
            if (this.workOrder.items && this.workOrder.items.length > 0) {
                this.workOrder.items.forEach(item => {
                    totalPaintingAreaWo +=
                        (+item.paintingArea || 0) * (+item.quantity || 0)
                })
            }
            return Number(totalPaintingAreaWo || 0).toFixed(1)
        },
        getTotalPieceLength() {
            let totalPieceLengthWo = 0
            if (this.workOrder.items && this.workOrder.items.length > 0) {
                this.workOrder.items.forEach(item => {
                    totalPieceLengthWo +=
                        (Number(item.pieceLength) || 0) * (+item.quantity || 0)
                })
            }
            return Number(totalPieceLengthWo || 0).toFixed(1)
        },
        getTotalPieceWidth() {
            let totalPieceWidthWo = 0
            if (this.workOrder.items && this.workOrder.items.length > 0) {
                this.workOrder.items.forEach(item => {
                    totalPieceWidthWo +=
                        (Number(item.pieceWidth) || 0) * (+item.quantity || 0)
                })
            }
            return Number(totalPieceWidthWo || 0).toFixed(1)
        },
        importFiles() {
            this.$emit('importFiles')
        },
        openAssemblyItemDetails(item, assembly) {
            this.itemsToShow = _.cloneDeep(
                (item.deliveries || []).map((delivery, index) => ({
                    ...item,
                    id: index,
                    workOrderId: item.workOrderId,
                    receivedQty: delivery.qty,
                }))
            )

            this.selectedAssembly = _.cloneDeep(assembly)
            this.assemblyItemDetails = true
        },
        closeAssemblyItemDetails() {
            this.itemsToShow = []
            this.selectedAssembly = null
            this.assemblyItemDetails = false
        },
        openReceiveItems() {
            this.$emit('openReceiveItems')
        },
        async getPartNumbers() {
            try {
                const collectionRef = firestore
                    .collection('companies')
                    .doc(this.user.companyId)
                    .collection('projects')
                    .doc(this.projectId)
                    .collection('partNumbers')

                collectionRef.onSnapshot(querySnapshot => {
                    this.partNumbers = []

                    querySnapshot.forEach(doc => {
                        const data = doc.data()
                        this.partNumbers.push({ id: doc.id, ...data })
                    })

                    this.partNumbers.sort((a, b) => a.number - b.number)

                    for (const index in this.partNumbers) {
                        const productionData = this.partNumbersProductionData[
                            this.partNumbers[index].id
                        ]
                        if (productionData) {
                            this.partNumbers[index] = {
                                ...this.partNumbers[index],
                                ...productionData,
                            }
                        }

                        this.partNumbers[
                            index
                        ].createdByName = this.getUserName(
                            this.partNumbers[index].createdBy
                        )
                    }
                    this.loading = false
                })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        formatPartNumbers() {
            this.partNumbers.forEach(partNumber => {
                if (this.partNumbersProductionData[partNumber.id]) {
                    partNumber.available = this.partNumbersProductionData[
                        partNumber.id
                    ].available
                }
            })
        },
        updatePartNumbers(partNumberUpdates) {
            this.closeAssemblyForm()
            partNumberUpdates.forEach(update => {
                const index = this.partNumbers.findIndex(
                    partNumber => partNumber.code == update.partNumber
                )
                if (index > -1) {
                    this.partNumbers[index].available -= update.updatedQty
                }
            })
        },
    },
}
</script>

<style>
#virtual-scroll-table {
    width: 100%;
    overflow: auto;
}

.selected-item {
    background-color: #dff0ff;
}

.alert-open-row {
    background-color: #fff9e6 !important;
}
.alert-resolved-row {
    background-color: #e6f3ff !important;
}
.alert-pending-approval-row {
    background-color: #f3e5f5 !important;
}
</style>
